import React from 'react';
import Store from '../../Common/Store.js';
import Utils from '../../Common/Utils.js';
import * as Style from '../Common/StyledComponents'

class Originalanswer extends React.Component
{
	render() {
		// Utils.log('this.props.clarification', this.props.clarification)
		let c = this.props.clarification
		// Utils.log('orig_answer', c)
		let cardata = this.props.cardata; //Store.getStoreData('cur_a_modal_data');
		// Utils.log('cardata', cardata)
		let object_data = JSON.parse(cardata.task_json).object_data
		Utils.log('object_data', object_data)
		let contact = Store.getStoreData('contact');
		Utils.log('contact', contact)
		let contacts = Store.getStoreData('contacts');
		Utils.log('contacts', contacts)
		let date = new Date(c.actiondate)
		let dateStr = date.toLocaleString('en-GB',{year: 'numeric', month: 'numeric', day: 'numeric',hour: '2-digit', minute: '2-digit'}).replace(/,/g, '')
		let bgColor = object_data.asked_by === c.performed_by ? '#F5C163' : '#04ACA7';

		let last_answer = c.note;
		if(Utils.isBase64(last_answer)){
		    last_answer = window.decodeURIComponent(atob(last_answer))
		}
		

		return (
				<Style.ModalNameInputDiv>
                    <Style.ModalWiderDiv>
                        <Style.ModalWiderLineDiv style={{width: '90%'}}/>
                        <Style.ModalClearDiv />
                        <Style.ModalWiderHeaderDiv style={{color: '#ffffff', paddingTop: '8px', paddingLeft: '15px', backgroundColor: bgColor, width: '93%'}}>
                        	{contacts[c.performed_by.toString()]}&nbsp;&nbsp;&nbsp;&nbsp;{dateStr}
                        </Style.ModalWiderHeaderDiv>
                        {/*<Style.ModalTextArea style={{width: '93.3%'}} name="answer" defaultValue={c.note.replace(/(&rsquo;)/g, "\'").replace(/'+/g,"'")} editable={false} readOnly={true} />*/}
                        <div style={{backgroundColor: '#FFFFFF', width: '94.5%'}}>
                        	<div dangerouslySetInnerHTML={{__html: last_answer}} style={{textAlign: "justify", padding: "10px"}}></div>
                        </div>
                    </Style.ModalWiderDiv>
                </Style.ModalNameInputDiv>
   			)
	}
} 

export default Originalanswer;